(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-first-fold-video"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = root => {
    root.querySelectorAll('[data-tl-ff-video]').forEach(widget => {
      if (widget.dataset.ready === 'true') return;
      widget.dataset.ready = 'true';
      const open = widget.querySelector('[data-tl-ff-video-open]');
      const dialog = widget.querySelector('dialog');
      const video = widget.querySelector('video');
      const close = widget.querySelector('[data-tl-ff-video-close]');
      const toggle = widget.querySelector('[data-tl-ff-video-toggle]');
      const status = widget.querySelector('[data-tl-ff-video-status]');
      if (!open || !dialog || !video || !close || !toggle || !status) return;
      const sync = () => { toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; };
      const play = () => {
        status.textContent = '';
        const attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(() => { status.textContent = status.dataset.retryLabel; sync(); });
      };
      open.addEventListener('click', () => {
        if (typeof dialog.showModal !== 'function') {
          status.textContent = status.dataset.errorLabel;
          dialog.setAttribute('open', '');
        } else if (!dialog.open) {
          dialog.showModal();
        }
        if (!video.getAttribute('src')) {
          video.setAttribute('poster', video.dataset.poster);
          video.setAttribute('src', video.dataset.src);
          video.load();
        }
        play();
      });
      toggle.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
      close.addEventListener('click', () => {
        video.pause();
        if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
        open.focus();
      });
      dialog.addEventListener('close', () => { video.pause(); sync(); open.focus(); });
      dialog.addEventListener('cancel', () => { video.pause(); });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      video.addEventListener('playing', () => { status.textContent = ''; });
      video.addEventListener('error', () => { status.textContent = status.dataset.errorLabel; sync(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
